import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_CHATURL } from '../../components/constants';

export const fetchChatHistory = createAsyncThunk(
  'history/fetchChatHistory',
  async ({ historyId, userId }) => {
    const response = await axios.get(`${BASE_CHATURL}/get-chat-history/${historyId}/${userId}`);
    return response.data;
  }
);

export const fetchChatHistoryByUser = createAsyncThunk(
  'history/fetchChatHistoryByUser',
  async (userId) => {
    const response = await axios.get(`${BASE_CHATURL}/get-chat-history-by-user/${userId}`);
    return response.data.history_records;
  }
);

const historySlice = createSlice({
  name: 'history',
  initialState: {
    chatHistory: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: {
    [fetchChatHistory.pending]: (state, action) => {
      state.status = 'loading';
    },
    [fetchChatHistory.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.chatHistory = action.payload;
    },
    [fetchChatHistory.rejected]: (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    },
    [fetchChatHistoryByUser.pending]: (state, action) => {
      state.status = 'loading';
    },
    [fetchChatHistoryByUser.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.chatHistory = action.payload;
    },
    [fetchChatHistoryByUser.rejected]: (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    },
  },
});

export default historySlice.reducer;

